import { render, staticRenderFns } from "./140.vue?vue&type=template&id=ef5ed5fc&scoped=true&"
import script from "./140.vue?vue&type=script&lang=js&"
export * from "./140.vue?vue&type=script&lang=js&"
import style0 from "./140.vue?vue&type=style&index=0&id=ef5ed5fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5ed5fc",
  null
  
)

export default component.exports